import React from 'react'

function SVGMessageSquare() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        stroke="#667085"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.667"
        d="M2.5 6.5c0-1.4 0-2.1.272-2.635a2.5 2.5 0 011.093-1.093C4.4 2.5 5.1 2.5 6.5 2.5h7c1.4 0 2.1 0 2.635.272a2.5 2.5 0 011.092 1.093C17.5 4.4 17.5 5.1 17.5 6.5V11c0 1.4 0 2.1-.273 2.635a2.5 2.5 0 01-1.092 1.092C15.6 15 14.9 15 13.5 15H8.07c-.52 0-.78 0-1.029.051a2.5 2.5 0 00-.635.223c-.226.115-.429.278-.835.603l-1.988 1.59c-.347.277-.52.416-.666.416a.417.417 0 01-.326-.157c-.091-.114-.091-.336-.091-.78V6.5z"
      ></path>
    </svg>
  )
}

export default SVGMessageSquare
